<template>
    <div class="container">
        <Header :isLight="isLight" :isMenuLight="isMenuLight" class="static-header"></Header>
        <h2 class="page-title">常见问题</h2>
        <div class="article-list">
            <ul>
                <li class="article-item" v-for="(item,index) in list" :key="item.id">
                    <h3 class="article-title">{{item.title}}</h3>
                    <div class="article-content" v-html="item.content">

                    </div>
                </li>
            </ul>
            <!-- <div class="bottom clearfix">
                <div class="bottom-page">
                    {{currentPage}}
                </div>
                <div class="toggle-btn-wrapper fr">
                    <a herf="javascript:;" class="toggle-btn toggle-btn-left" :class="{disabled:currentPage <=1}" @click="handlePrev">
                        <Icon type="ios-arrow-back"></Icon>
                    </a>
                    <a herf="javascript:;" class="toggle-btn" :class="{disabled:currentPage >= totalPages}" @click="handleNext">
                        <Icon type="ios-arrow-forward"></Icon>
                    </a>
                </div>
            </div> -->
        </div>
        <div class="pagin">
            <Page :total="totalPages" :page-size="6" size="small" @on-change="handlePageChange"></Page>
        </div>
        <!-- <div class="page">
            <div class="current">{{currentPage}}</div>
            <div class="bar"></div>
            <div class="total">{{totalPages}}</div>
        </div> -->
        <Bottom></Bottom>
    </div>
</template>
<script>
import Header from '@/components/Header'
import Bottom from '@/components/Bottom'
import api from '@/api/api'
import dataStatistics from '@/assets/js/dataStatistics'
export default {
    name: 'news',
    components: {
        Header,
        Bottom
    },
    data() {
        return {
            isLight: false,
            isMenuLight: false,
            currentPage: 1,
            totalPages: 0,

            list: []
        }
    },
    created() {
        this.getFaqList(1)
        dataStatistics('PC-常见问题页', '进入','文章浏览')
    },

    methods: {
        getFaqList(page) {
            const params = {
                pageNum: page,
                pageSize: 6
            }
            api.faq.faqList(params).then(res => {
                if (res.data.code === 200) {
                    this.list = res.data.data.list
                    this.totalPages = res.data.data.total
                    window.scrollTo(0, 0)
                }
            })
        },
        handlePageChange(page) {
            this.getFaqList(page)
        },
        // handlePrev() {
        //     this.currentPage--
        //     this.currentPage = this.currentPage <= 1 ? 1 : this.currentPage
        //     if (this.currentPage <= 0) {
        //         return
        //     }
        //     this.getFaqList()
        // },
        // handleNext() {
        //     this.currentPage++
        //     this.currentPage =
        //         this.currentPage >= this.totalPages ? this.totalPages : this.currentPage
        //     if (this.currentPage > this.totalPages) {
        //         return
        //     }
        //     this.getFaqList()
        // }
    }
}
</script>
<style lang="less" scoped>
.container {
    padding-top: 100px;
}
.page-title {
  text-align: center;
  margin-bottom: 0.5rem;
  font-family: PingFangSC-Regular;
  font-size: 0.38rem;
  color: #000000;
  font-weight: normal;
}
.article-list {
  width: 70%;
  margin: 0 auto;
  position: relative;
  min-height: 600px;
}
.article-title {
  font-family: PingFangSC-Regular;
  font-size: 0.24rem;
  color: #333333;
  line-height: 36px;
  font-weight: normal;
  &:hover {
    color: #FF7D41;
  }
}
.article-item {
  margin-bottom: 0.6rem;

  &:last-child {
    margin-bottom: 0;
  }
}
.article-content {
  font-family: PingFangSC-Regular;
  font-size: 0.18rem;
  color: #666666;
  line-height: 38px;
 /deep/ img {
    max-width: 100%!important;
  }
 /deep/ a {
    color: #FF7D41;
  }
}
.toggle-btn-wrapper {
  position: absolute;
  right: 0;
}
.toggle-btn {
  color: #343434;
  float: left;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 0.72rem;
  height: 0.72rem;
  border-radius: 50%;
  cursor: pointer;
  &:hover {
    border: 2px solid #343434;
  }
  .ivu-icon {
    font-size: 30px;
  }
}
.bottom {
  position: relative;
  height: 0.72rem;
  margin-top: 40px;
  margin-bottom: 50px;
}
.bottom-page {
  position: absolute;
  bottom: 0;
  left: 50%;
  background: #f5f5f5;
  border: 1px solid #d0d0d0;
  border-radius: 3px;
  width: 0.6rem;
  height: 0.36rem;
  text-align: center;
  line-height: 0.36rem;
  font-family: PingFangSC-Regular;
  font-size: 16px;
  color: #333333;
}
.toggle-btn-left {
  margin-right: 30px;
}
.page {
  position: fixed;
  top: 50%;
  transform: translateY(-50%);
  left: 10px;
  z-index: 2018;
  font-size: 0.28rem;
  color: #000000;
  width: 0.2rem;
  text-align: center;
  > div {
    width: 0.38rem;
  }
  .bar {
    height: 2px;
    background: #9b9b9b;
  }
}
.disabled {
  cursor: not-allowed;
  &:hover {
    border: none;
  }
  .ivu-icon {
    color: #ddd;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/FAQ.vue